import { Box, styled } from '@mui/material'
import { designTokens } from '@/theme'

export const RoundedBox = styled(Box)(({ theme }) => ({
    background: theme.palette.background.paper,
    borderRadius: `${designTokens.shape.borderRadius.lg}px`,
}))